import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { ReactElement, useCallback, useEffect } from 'react'
import styled from 'styled-components'
import { GlobalVariables } from 'Globals/GlobalVariables'
import Comparison from 'components/Comparison'
import UserInput from 'components/UserInput'
import {
  ContentWidth,
  TextWidthExtended,
  TextWidth,
} from '@ta-interaktiv/react-disco-grid'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
}: MicroFrontendProps) => {
  const parsedData =
    properties && properties?.data
      ? JSON.parse('[' + properties?.data + ']')
      : undefined // properties ? JSON.parse(properties?.data) : undefined
  const parsedOptions =
    properties && properties?.options
      ? JSON.parse('[' + properties?.options + ']')
      : undefined // properties ? JSON.parse(properties?.data) : undefined
  const parsedDetails =
    properties && properties?.details
      ? JSON.parse('[' + properties?.details + ']')
      : undefined // properties ? JSON.parse(properties?.data) : undefined
  const modules: { [key: string]: ReactElement } = {
    comparison: (
      <>
        {parsedData && (
          <TextWidth>
            <Comparison
              data={parsedData}
              details={parsedDetails}
              colorMode={colorMode}
            />
          </TextWidth>
        )}
      </>
    ),
    userinput: <UserInput options={parsedOptions} colorMode={colorMode} />,
  }

  return (
    <AppContainer $colorMode={colorMode}>
      {properties && <>{modules[properties.module]}</>}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  @media only screen and (max-width: 1111px) {
    padding: 0 1rem 0;
  }
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`

export default MainComponent
